import { useState } from 'react'
import { useValidate } from '../Validation/Validation'

export function useFormInput(initValue = {}) {
  const initValidation = {
    validation: {
      isValid: initValue.valid,
      errors: [],
      rules: initValue.validation
    }
  }

  const [data, setData] = useState({
    value: initValue.value,
    ...initValidation
  })

  function handleChange(e) {
    let newData = _.cloneDeep(data)
    initValue.validation = newData.validation.rules
    const validated = useValidate(e, initValue)
    newData = {...newData, ...validated}
    setData(newData)
  }

  function clear() {
    setData({
      ...data,
      value: '',
      ...initValidation
    })
  }

  function updateData(newData) {
    setData(newData)
  }


  return [
    {
      value: data.value,
      type: initValue.type,
      label: initValue.label,
      id: initValue.id ? initValue.id : initValue.name,
      className: initValue.className,
      name: initValue.name,
      placeholder: initValue.placeholder,
      validation: data.validation,
      style: data.validation.isValid === false ? { border: '1px solid red' } : {},
      onChange: handleChange,
      options: data.options ? data.options : initValue.options,
      disabled: data.disabled !== undefined ? data.disabled : initValue.disabled,
      maxage:  data.maxage,
      minage: data.minage
    },
    () => clear(),
    (data) => updateData(data)
  ]
}
